(function () {
  if (window.__trMetaSlideshowBound) return;
  window.__trMetaSlideshowBound = true;

  function boolFromData(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    if (typeof value === 'boolean') return value;
    var normalized = String(value).toLowerCase().trim();
    if (normalized === 'true' || normalized === '1') return true;
    if (normalized === 'false' || normalized === '0') return false;
    return fallback;
  }

  function numberFromData(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getSyncTextTarget(section, slotKey) {
    if (!section || !slotKey) return null;
    var targets = section.querySelectorAll('[data-tr-sync-text-target="true"]');
    for (var i = 0; i < targets.length; i += 1) {
      if (String(targets[i].dataset.trSyncSlot || '').toLowerCase() === String(slotKey).toLowerCase()) {
        return targets[i];
      }
    }
    return null;
  }

  function readSyncPayloadFromSlide(slide) {
    if (!slide) return null;
    var payloadRoot = slide.querySelector('[data-tr-sync-payload]');
    if (!payloadRoot) return null;
    var bodyNode = payloadRoot.querySelector('[data-tr-sync-body-markup]');
    return {
      eyebrow: payloadRoot.dataset.eyebrow || '',
      heading: payloadRoot.dataset.heading || '',
      buttonLabel: payloadRoot.dataset.buttonLabel || '',
      buttonUrl: payloadRoot.dataset.buttonUrl || '',
      bodyHtml: bodyNode ? bodyNode.innerHTML : ''
    };
  }

  function bodyMarkupHasContent(html) {
    if (!html) return false;
    var probe = document.createElement('div');
    probe.innerHTML = html;
    var text = (probe.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (text) return true;
    return !!probe.querySelector('img, video, iframe');
  }

  function ensureSyncTextDefaults(targetCard) {
    if (!targetCard || targetCard.dataset.trSyncDefaultsReady === '1') return;

    var eyebrowEl = targetCard.querySelector('[data-tr-sync-eyebrow-target]');
    var headingEl = targetCard.querySelector('[data-tr-sync-heading-target]');
    var rteEl = targetCard.querySelector('[data-tr-sync-rte-target]');
    var buttonEl = targetCard.querySelector('[data-tr-sync-button-target]');

    targetCard.__trSyncDefaults = {
      eyebrow: eyebrowEl ? (eyebrowEl.textContent || '') : '',
      heading: headingEl ? (headingEl.textContent || '') : '',
      bodyHtml: rteEl ? rteEl.innerHTML : '',
      buttonLabel: buttonEl ? (buttonEl.textContent || '') : '',
      buttonUrl: buttonEl ? (buttonEl.getAttribute('href') || '') : ''
    };
    targetCard.dataset.trSyncDefaultsReady = '1';
  }

  function applySyncPayloadToTextCard(targetCard, payload) {
    if (!targetCard || !payload) return;

    ensureSyncTextDefaults(targetCard);
    var defaults = targetCard.__trSyncDefaults || {};

    var eyebrowEl = targetCard.querySelector('[data-tr-sync-eyebrow-target]');
    var headingEl = targetCard.querySelector('[data-tr-sync-heading-target]');
    var rteWrapEl = targetCard.querySelector('[data-tr-sync-rte-wrap-target]');
    var rteEl = targetCard.querySelector('[data-tr-sync-rte-target]');
    var buttonEl = targetCard.querySelector('[data-tr-sync-button-target]');

    var eyebrowText = (payload.eyebrow || '').trim() ? payload.eyebrow : (defaults.eyebrow || '');
    var headingText = (payload.heading || '').trim() ? payload.heading : (defaults.heading || '');
    var bodyHtml = bodyMarkupHasContent(payload.bodyHtml) ? payload.bodyHtml : (defaults.bodyHtml || '');
    var payloadButtonLabel = (payload.buttonLabel || '').trim();
    var payloadButtonUrl = (payload.buttonUrl || '').trim();
    var buttonLabel = payloadButtonLabel ? payload.buttonLabel : '';
    var buttonUrl = payloadButtonLabel ? (payloadButtonUrl || defaults.buttonUrl || '') : '';

    function setElementVisible(element, visible) {
      if (!element) return;
      if (visible) {
        element.removeAttribute('hidden');
        element.style.display = '';
      } else {
        element.setAttribute('hidden', '');
        element.style.display = 'none';
      }
    }

    if (eyebrowEl) {
      eyebrowEl.textContent = eyebrowText;
      setElementVisible(eyebrowEl, Boolean((eyebrowText || '').trim()));
    }

    if (headingEl) {
      headingEl.textContent = headingText;
      setElementVisible(headingEl, Boolean((headingText || '').trim()));
    }

    if (rteEl) {
      rteEl.innerHTML = bodyHtml;
      rteEl.scrollTop = 0;
      if (rteWrapEl) setElementVisible(rteWrapEl, bodyMarkupHasContent(bodyHtml));
      rteEl.dispatchEvent(new Event('scroll'));
      requestAnimationFrame(function () {
        rteEl.dispatchEvent(new Event('scroll'));
      });
    } else if (rteWrapEl) {
      setElementVisible(rteWrapEl, false);
    }

    if (buttonEl) {
      buttonEl.textContent = buttonLabel;
      if (buttonUrl) buttonEl.setAttribute('href', buttonUrl);
      else if (defaults.buttonUrl) buttonEl.setAttribute('href', defaults.buttonUrl);
      setElementVisible(buttonEl, Boolean((buttonLabel || '').trim()));
    }
  }

  function tempoBoostFromPercent(percent) {
    var normalized = Math.max(0, Math.min(100, numberFromData(percent, 0))) / 100;
    if (normalized <= 0) return 0;
    return Math.min(1, Math.pow(normalized, 0.75) * 1.35);
  }

  function initSlider(container) {
    if (!container || container.dataset.trMetaSliderReady === '1') return;
    container.dataset.trMetaSliderReady = '1';

    var slides = container.querySelectorAll('.tr-slide');
    if (!slides.length) return;

    var nextBtn = container.querySelector('.tr-next');
    var prevBtn = container.querySelector('.tr-prev');
    var dotButtons = container.querySelectorAll('.tr-dot');
    var textOverlays = container.querySelectorAll('.tr-text-overlay');

    var enableAutoplay = boolFromData(container.dataset.autoplay, true);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) enableAutoplay = false;
    var baseIntervalTime = numberFromData(container.dataset.intervalMs, 5000);
    if (!Number.isFinite(baseIntervalTime) || baseIntervalTime <= 0) baseIntervalTime = 5000;
    var enableSwipeDrag = boolFromData(container.dataset.enableSwipeDrag, true);
    var swipeThresholdMobile = numberFromData(container.dataset.swipeThresholdMobile, 40);
    var swipeThresholdDesktop = numberFromData(container.dataset.swipeThresholdDesktop, 50);
    var tempoBoostPercent = Math.max(0, Math.min(100, numberFromData(container.dataset.tempoBoost, 0)));
    var tempoBoost = tempoBoostFromPercent(tempoBoostPercent);
    var cardRoot = container.closest('.tr-collage-card');
    var tempoFill = cardRoot && cardRoot.querySelector('[data-tr-card-tempo-fill]');
    var tempoTrack = cardRoot && cardRoot.querySelector('.tr-collage-card__tempo');
    var titleTarget = cardRoot && cardRoot.querySelector('[data-tr-meta-slider-title]');

    var mobileSwipeQuery = window.matchMedia('(max-width: 989px)');
    var swipeIntentThreshold = 10;
    var currentIndex = 0;
    var syncTextTarget = null;
    var advanceTimer = null;
    var tempoRaf = 0;
    var cycleStartAt = 0;
    var cycleElapsedMs = 0;
    var pauseReasons = new Set();
    var clickPauseTimer = null;
    var currentIntervalTime = baseIntervalTime;

    var touchStartX = 0;
    var touchStartY = 0;
    var touchCurrentX = 0;
    var touchCurrentY = 0;
    var isTouchTracking = false;

    var mouseStartX = 0;
    var mouseStartY = 0;
    var mouseCurrentX = 0;
    var mouseCurrentY = 0;
    var isMouseTracking = false;
    var suppressClickUntil = 0;

    if (container.dataset.trSyncSource === 'true') {
      var syncSection = container.closest('.tr-builder-section');
      var syncTargetSlot = String(container.dataset.trSyncTargetSlot || '').trim();
      syncTextTarget = getSyncTextTarget(syncSection, syncTargetSlot);
      ensureSyncTextDefaults(syncTextTarget);
    }

    function getViewportScale() {
      if (window.visualViewport && Number.isFinite(window.visualViewport.scale)) {
        return window.visualViewport.scale;
      }
      return 1;
    }

    function isZoomed() {
      return getViewportScale() > 1.01;
    }

    function slideChangeAllowed() {
      return !isZoomed();
    }

    function getSlideVideoElement(slide) {
      if (!slide) return null;
      return slide.querySelector('video');
    }

    function pauseAllSlideVideos() {
      slides.forEach(function (slide) {
        var video = getSlideVideoElement(slide);
        if (!video) return;
        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {}
      });
    }

    function syncSlideMediaPlayback() {
      slides.forEach(function (slide, index) {
        var video = getSlideVideoElement(slide);
        if (!video) return;
        if (index === currentIndex) {
          video.muted = true;
          video.playsInline = true;
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
          return;
        }
        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {}
      });
    }

    function resolveSlideIntervalMs(slide) {
      var slideInterval = numberFromData(slide && slide.dataset ? slide.dataset.intervalMs : undefined, NaN);
      if (Number.isFinite(slideInterval) && slideInterval > 0) return slideInterval;
      return baseIntervalTime;
    }

    function refreshCurrentInterval() {
      currentIntervalTime = resolveSlideIntervalMs(slides[currentIndex]);
      if (!Number.isFinite(currentIntervalTime) || currentIntervalTime <= 0) currentIntervalTime = baseIntervalTime;
    }

    function updateDots() {
      if (!dotButtons.length) return;
      dotButtons.forEach(function (dot, index) {
        var isActive = index === currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updateTitle() {
      if (!titleTarget) return;
      var nextTitle = '';
      if (slides[currentIndex] && slides[currentIndex].dataset && slides[currentIndex].dataset.title) {
        nextTitle = slides[currentIndex].dataset.title.trim();
      }

      if (nextTitle) {
        titleTarget.textContent = nextTitle;
        titleTarget.hidden = false;
      } else {
        titleTarget.textContent = '';
        titleTarget.hidden = true;
      }
    }

    function setTempoProgress(progress) {
      if (!tempoFill) return;
      var normalized = Math.max(0, Math.min(1, progress));
      var fillStartOpacity = 0.18 + tempoBoost * 0.2;
      var fillEndOpacity = 0.8 + tempoBoost * 0.18;
      var trackStartOpacity = 0.08 + tempoBoost * 0.14;
      var trackEndOpacity = 0.16 + tempoBoost * 0.2;
      var trackBaseHeight = 2;
      var trackMaxHeight = 3.2 + tempoBoost * 1.4;
      var visibleWidth = Math.max(0.015, normalized);

      tempoFill.style.width = (visibleWidth * 100).toFixed(2) + '%';
      tempoFill.style.opacity = (fillStartOpacity + (fillEndOpacity - fillStartOpacity) * normalized).toFixed(3);

      if (tempoTrack) {
        var trackHeight = trackBaseHeight + (trackMaxHeight - trackBaseHeight) * normalized;
        var trackOpacity = trackStartOpacity + (trackEndOpacity - trackStartOpacity) * normalized;
        tempoTrack.style.height = trackHeight.toFixed(2) + 'px';
        tempoTrack.style.opacity = trackOpacity.toFixed(3);
      }
    }

    function stopTempoLoop() {
      if (!tempoRaf) return;
      cancelAnimationFrame(tempoRaf);
      tempoRaf = 0;
    }

    function onTempoFrame(now) {
      if (!enableAutoplay || slides.length < 2 || pauseReasons.size > 0) {
        stopTempoLoop();
        return;
      }
      var elapsed = cycleElapsedMs;
      if (cycleStartAt) elapsed += Math.max(0, now - cycleStartAt);
      setTempoProgress(elapsed / currentIntervalTime);
      tempoRaf = requestAnimationFrame(onTempoFrame);
    }

    function startTempoLoop() {
      stopTempoLoop();
      if (!enableAutoplay || slides.length < 2 || pauseReasons.size > 0) return;
      tempoRaf = requestAnimationFrame(onTempoFrame);
    }

    function clearAdvanceTimer() {
      if (!advanceTimer) return;
      clearTimeout(advanceTimer);
      advanceTimer = null;
    }

    function captureCycleElapsed() {
      if (!cycleStartAt) return;
      cycleElapsedMs += Math.max(0, performance.now() - cycleStartAt);
      if (cycleElapsedMs > currentIntervalTime) cycleElapsedMs = currentIntervalTime;
      cycleStartAt = 0;
    }

    function scheduleAdvance() {
      clearAdvanceTimer();
      stopTempoLoop();

      if (!enableAutoplay || slides.length < 2 || pauseReasons.size > 0) return;

      refreshCurrentInterval();
      if (cycleElapsedMs >= currentIntervalTime) cycleElapsedMs = 0;
      cycleStartAt = performance.now();
      startTempoLoop();

      var remaining = Math.max(50, currentIntervalTime - cycleElapsedMs);
      advanceTimer = setTimeout(function () {
        cycleElapsedMs = 0;
        cycleStartAt = 0;
        if (!nextSlide()) scheduleAdvance();
      }, remaining);
    }

    function pauseAutoplay(reason) {
      if (!enableAutoplay || slides.length < 2) return;
      if (pauseReasons.has(reason)) return;
      pauseReasons.add(reason);
      captureCycleElapsed();
      clearAdvanceTimer();
      stopTempoLoop();
      setTempoProgress(cycleElapsedMs / currentIntervalTime);
    }

    function resumeAutoplay(reason) {
      if (!pauseReasons.has(reason)) return;
      pauseReasons.delete(reason);
      if (pauseReasons.size === 0) scheduleAdvance();
    }

    function pauseOnClickTemporarily(ms) {
      pauseAutoplay('click');
      if (clickPauseTimer) clearTimeout(clickPauseTimer);
      clickPauseTimer = setTimeout(function () {
        clickPauseTimer = null;
        resumeAutoplay('click');
      }, ms);
    }

    function showSlide(index) {
      if (!slideChangeAllowed()) return false;
      slides[currentIndex].classList.remove('active');

      if (index >= slides.length) currentIndex = 0;
      else if (index < 0) currentIndex = slides.length - 1;
      else currentIndex = index;

      slides[currentIndex].classList.add('active');
      syncSlideMediaPlayback();
      updateDots();
      updateTitle();
      if (syncTextTarget) {
        applySyncPayloadToTextCard(syncTextTarget, readSyncPayloadFromSlide(slides[currentIndex]));
      }
      cycleElapsedMs = 0;
      refreshCurrentInterval();
      setTempoProgress(0);
      scheduleAdvance();
      return true;
    }

    function nextSlide() {
      return showSlide(currentIndex + 1);
    }

    function prevSlide() {
      return showSlide(currentIndex - 1);
    }

    function maybeTriggerSwipe(deltaX, deltaY) {
      var swipeThreshold = mobileSwipeQuery.matches ? swipeThresholdMobile : swipeThresholdDesktop;
      if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (!slideChangeAllowed()) return false;
        if (deltaX < 0) return nextSlide();
        return prevSlide();
      }
      return false;
    }

    function onTouchStart(event) {
      if (!enableSwipeDrag || slides.length < 2) return;
      if (!mobileSwipeQuery.matches) return;
      if (event.touches.length !== 1) return;
      if (isZoomed()) return;

      var touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchCurrentX = touch.clientX;
      touchCurrentY = touch.clientY;
      isTouchTracking = true;
      pauseAutoplay('touch');
    }

    function onTouchMove(event) {
      if (!isTouchTracking) return;
      if (event.touches.length !== 1) return;
      if (isZoomed()) return;

      var touch = event.touches[0];
      touchCurrentX = touch.clientX;
      touchCurrentY = touch.clientY;

      var deltaX = touchCurrentX - touchStartX;
      var deltaY = touchCurrentY - touchStartY;

      if (Math.abs(deltaX) > swipeIntentThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault();
      }
    }

    function onTouchEnd() {
      if (!isTouchTracking) return;

      var deltaX = touchCurrentX - touchStartX;
      var deltaY = touchCurrentY - touchStartY;
      maybeTriggerSwipe(deltaX, deltaY);

      isTouchTracking = false;
      resumeAutoplay('touch');
    }

    function onTouchCancel() {
      isTouchTracking = false;
      resumeAutoplay('touch');
    }

    function isInteractiveTarget(target) {
      return Boolean(target && target.closest('a, button, input, select, textarea, summary, details'));
    }

    function onMouseDown(event) {
      if (!enableSwipeDrag || slides.length < 2) return;
      if (event.button !== 0) return;
      if (isInteractiveTarget(event.target)) return;
      if (isZoomed()) return;

      isMouseTracking = true;
      mouseStartX = event.clientX;
      mouseStartY = event.clientY;
      mouseCurrentX = event.clientX;
      mouseCurrentY = event.clientY;
      pauseAutoplay('pointer');
      container.classList.add('tr-dragging');

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
      window.addEventListener('blur', onMouseUp);
    }

    function onMouseMove(event) {
      if (!isMouseTracking) return;

      mouseCurrentX = event.clientX;
      mouseCurrentY = event.clientY;

      var deltaX = mouseCurrentX - mouseStartX;
      var deltaY = mouseCurrentY - mouseStartY;
      if (Math.abs(deltaX) > swipeIntentThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        event.preventDefault();
      }
    }

    function onMouseUp() {
      if (!isMouseTracking) return;

      var deltaX = mouseCurrentX - mouseStartX;
      var deltaY = mouseCurrentY - mouseStartY;
      var didSwipe = maybeTriggerSwipe(deltaX, deltaY);
      if (didSwipe) suppressClickUntil = Date.now() + 350;

      isMouseTracking = false;
      container.classList.remove('tr-dragging');
      resumeAutoplay('pointer');

      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('blur', onMouseUp);
    }

    function onContainerClickCapture(event) {
      if (Date.now() > suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!slideChangeAllowed()) return;
        nextSlide();
        pauseOnClickTemporarily(2500);
      });
      nextBtn.addEventListener('mouseenter', function () {
        pauseAutoplay('nav-hover');
      });
      nextBtn.addEventListener('mouseleave', function () {
        resumeAutoplay('nav-hover');
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!slideChangeAllowed()) return;
        prevSlide();
        pauseOnClickTemporarily(2500);
      });
      prevBtn.addEventListener('mouseenter', function () {
        pauseAutoplay('nav-hover');
      });
      prevBtn.addEventListener('mouseleave', function () {
        resumeAutoplay('nav-hover');
      });
    }

    textOverlays.forEach(function (overlay) {
      overlay.addEventListener('mouseenter', function () {
        pauseAutoplay('overlay-hover');
      });
      overlay.addEventListener('mouseleave', function () {
        resumeAutoplay('overlay-hover');
      });
    });

    dotButtons.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!slideChangeAllowed()) return;
        var nextIndex = Number(dot.dataset.dotIndex);
        if (Number.isNaN(nextIndex)) return;
        showSlide(nextIndex);
        pauseOnClickTemporarily(2500);
      });
    });

    if (enableSwipeDrag && slides.length > 1) {
      container.classList.add('tr-drag-enabled');
      container.addEventListener('touchstart', onTouchStart, { passive: true });
      container.addEventListener('touchmove', onTouchMove, { passive: false });
      container.addEventListener('touchend', onTouchEnd, { passive: true });
      container.addEventListener('touchcancel', onTouchCancel, { passive: true });
      container.addEventListener('mousedown', onMouseDown);
      container.addEventListener('click', onContainerClickCapture, true);
    }

    container.addEventListener('mouseenter', function () {
      pauseAutoplay('hover');
    });
    container.addEventListener('mouseleave', function () {
      resumeAutoplay('hover');
    });

    function onSyncTargetFocusOut() {
      setTimeout(function () {
        if (!syncTextTarget || !syncTextTarget.contains(document.activeElement)) resumeAutoplay('sync-focus');
      }, 0);
    }

    if (syncTextTarget) {
      syncTextTarget.addEventListener('mouseenter', function () {
        pauseAutoplay('sync-hover');
      });
      syncTextTarget.addEventListener('mouseleave', function () {
        resumeAutoplay('sync-hover');
      });
      syncTextTarget.addEventListener('focusin', function () {
        pauseAutoplay('sync-focus');
      });
      syncTextTarget.addEventListener('focusout', onSyncTargetFocusOut);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pauseAutoplay('hidden');
        pauseAllSlideVideos();
      } else {
        resumeAutoplay('hidden');
        syncSlideMediaPlayback();
      }
    });

    refreshCurrentInterval();
    syncSlideMediaPlayback();
    updateDots();
    updateTitle();
    if (syncTextTarget) {
      applySyncPayloadToTextCard(syncTextTarget, readSyncPayloadFromSlide(slides[currentIndex]));
    }
    setTempoProgress(0);
    scheduleAdvance();
  }

  function initAll(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('[data-tr-meta-slider]');
    containers.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
